<template>
  <div class="bg-background-yellow">
    <div class="container">
      <div class="m:flex m:items-center m:justify-center">
        <div class="py-6 m:py-11">
          <b-headline type="h1" typography="h15" class="mb-6 m:mb-8 m:pt-5" v-html="$t('connect')" />
          <div v-html="$t('body')" class="text-base m:text-xl m:mb-6" />
        </div>
        <div class="text-center">
          <faq-image class="m:w-5/12 l:w-6/12 m:pl-1 m:pt-4 l:pt-0 l:pl-20" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FaqImage from "./faq-image"
import BHeadline from "@/component-library/b-headline"

export default {
  name: "ConnectFaqHeroSection",
  components: {
    FaqImage,
    BHeadline
  },
  i18n: {
    messages: {
      en: {
        connect: "Blinkist Premium sharing",
        body: "Your Blinkist Premium plan now comes with an extra account for free. Share the joy of learning together!"
      },
      de: {
        connect: "Teile Blinkist Premium",
        body: "Geteilte Aha-Momente sind die besten Aha-Momente! Deshalb kannst du jetzt kostenlos ein Extra-Konto in deinem Abo mit einer Person teilen."
      }
    }
  }
}
</script>
